import "../chunk-7B52C2XE.js";
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["DEV"] = "DEV";
  Environment2["SANDBOX"] = "SANDBOX";
  Environment2["BETA"] = "BETA";
  Environment2["PROD"] = "PROD";
  Environment2["DEVELOPMENT"] = "BETA";
  Environment2["PRODUCTION"] = "PROD";
  return Environment2;
})(Environment || {});
var EnabledFlow = /* @__PURE__ */ ((EnabledFlow2) => {
  EnabledFlow2["BUY"] = "BUY";
  EnabledFlow2["RECEIVE"] = "RECEIVE";
  EnabledFlow2["WITHDRAW"] = "WITHDRAW";
  return EnabledFlow2;
})(EnabledFlow || {});
export {
  EnabledFlow,
  Environment
};
